import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  methods: [],
  choosenMethod: {},
  dalenysToken: '',
  tokenizationError: '',
  hostedFields: {}
};

export default {
  state,
  mutations,
  getters,
  actions,
};
